import api from '.'
import { ILoginResponse, IUserResponse, LoginInput } from './types'
import { logger } from '../utils/logger'

export const loginUserFn = async (user: LoginInput) => {
  try {
    const response = await api.post<ILoginResponse>('auth/customers/login', user)
    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Login error'), {
      type: 'login_error',
      email: user.email
    })
    throw error
  }
}

export const getMeFn = async () => {
  try {
    const response = await api.get<IUserResponse>('auth/customer')
    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Get user error'), {
      type: 'get_user_error'
    })
    throw error
  }
}
